import { Textarea } from '@/components/ui/textarea'

const LongTextField = ({ field, id = field.id, value, onChange, disabled }) => (
  <Textarea
    id={id}
    value={value || ''}
    onChange={(e) => onChange(e.target.value)}
    placeholder={field.label}
    rows={3}
    disabled={disabled}
  />
)

export default LongTextField
